import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {animateScroll as scroll} from 'react-scroll';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {
	codigoPostalErroneo,
	telefonoErroneo,
	datosVacio,
	validarDNI,
	validarNISS,
} from '../../fuctions/validacionFormularios';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import {makeStyles} from '@material-ui/core/styles';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export const FormularioMisPacientes = (props) => {
	const {
		setPantallaPerfil,
		guardarCambios,
		Paciente,
		setPaciente,
		idPaciente,
		setIdPaciente,
		ErroresFormulario,
		setErroresFormulario,
		ModalErrores,
		setModalErrores,
	} = props;

	/* Creating a state variable called ListaProvincias and a function to update it called
setListaProvincias. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [ListaProvincias, setListaProvincias] = useState([]);
	const [Provincia, setProvincia] = useState('');

	const [FotoPerfilCambiar, setFotoPerfilCambiar] = useState({});
	const [ModalCambiarFotoPerfil, setModalCambiarFotoPerfil] = useState(false);
	const [ModalFotoCambiadaOK, setModalFotoCambiadaOK] = useState(false);
	const [ModalFotoCambiadaNoOK, setModalFotoCambiadaNoOK] = useState(false);
	/* Creating a state variable called ListaLocalidades and a function to update it called
    setListaLocalidades. */
	const [ListaLocalidades, setListaLocalidades] = useState([]);
	const [Localidad, setLocalidad] = useState('');

	const useStyles = makeStyles((theme) => ({
		customTooltip: {
			fontSize: '0.9em',
			textAlign: 'justify',
		},
	}));

	const [ListaNombresProvincias, setListaNombresProvincias] = useState([]);

	const actualizarFoto = () => {
		let correct = false;
		if (FotoPerfilCambiar !== null) {
			if (FotoPerfilCambiar !== undefined) {
				if (FotoPerfilCambiar.fotoPerfil !== null) {
					if (FotoPerfilCambiar.fotoPerfil !== undefined) {
						if (
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpg' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/png' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpeg'
						) {
							if (idPaciente !== undefined) {
								selectFotoPerfil(Usuario, 1);
							} else {
								setPaciente({
									...Paciente,
									fotoPaciente: URL.createObjectURL(FotoPerfilCambiar.fotoPerfil),
								});
								setModalCambiarFotoPerfil(false);
							}
							correct = true;
						}
					}
				}
			}
		}
		if (!correct) {
			setModalFotoCambiadaNoOK(true);
		}
	};
	/**
	 * It gets the image of the user from the database and then calls the function colocarFoto()
	 * @param {Object} usuario - The user object containing the access token and user data.
	 */
	const selectFotoPerfil = (funtion) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilPaciente/?paciente_id=' + Paciente.id,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				if (funtion === 0) {
					return colocarFoto(response.data[0]);
				} else {
					return borrarFotoAntigua(response.data[0]);
				}
			})
			.catch((error) => {
				console.error(error);
				setErroresFormulario([
					'Error al cargar la foto de perfil 2 ' + error + ' -> ' + funtion,
				]);
				setModalErrores(true);
			});
	};

	const colocarFoto = (foto) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilPaciente/' + foto.id.toString() + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			responseType: 'blob',
		})
			.then((response) => {
				setPaciente({
					...Paciente,
					fotoPaciente: URL.createObjectURL(response.data),
				});
			})
			.catch((error) => {
				setErroresFormulario(['Error al cargar la foto de perfil 1' + error.toString()]);
				setModalErrores(true);
			});
	};
	const borrarFotoAntigua = (foto) => {
		axios({
			url:
				window.ipdirection +
				'imagenPerfilPaciente/' +
				foto.id.toString() +
				'/?paciente_id=' +
				Paciente.id,
			method: 'delete',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				cambiarFotoPerfil();
			})
			.catch((error) => {
				setErroresFormulario(['Fallo al actualizar su foto de perfil' + error.toString()]);
				setModalErrores(true);
			});
	};

	const cambiarFotoPerfil = () => {
		const formData = new FormData();
		const imagenOriginal = new Image(); // Crear un objeto imagen
		imagenOriginal.src = URL.createObjectURL(FotoPerfilCambiar.fotoPerfil); // Cargar la imagen en el objeto

		// Esperar a que la imagen se cargue
		imagenOriginal.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Definir la resolución deseada
			const ancho = 300; // ancho deseado
			const alto = 300; // alto deseado

			canvas.width = ancho;
			canvas.height = alto;

			// Set image scale
			let scaleFactor = Math.max(
				canvas.width / imagenOriginal.width,
				canvas.height / imagenOriginal.height
			);

			// Finding the new width and height based on the scale factor
			let newWidth = imagenOriginal.width * scaleFactor;
			let newHeight = imagenOriginal.height * scaleFactor;

			// get the top left position of the image
			// in order to center the image within the canvas
			let x = canvas.width / 2 - newWidth / 2;
			let y = canvas.height / 2 - newHeight / 2;

			ctx.drawImage(imagenOriginal, x, y, newWidth, newHeight);

			canvas.toBlob((blob) => {
				//formData.append("documento", File);
				formData.append('imagen', blob, Paciente.nombrePaciente + '.png');
				formData.append('nombre', 'FotoPerfil-' + Paciente.nombrePaciente);
				//formData.append("nombre", "Prueba");
				formData.append('paciente_id', Paciente.id);

				axios
					.post(window.ipdirection + 'imagenPerfilPaciente/', formData, {
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
					})
					.then((response) => {
						selectFotoPerfil(0);
						setModalCambiarFotoPerfil(false);
						setModalFotoCambiadaOK(true);
					})
					.catch((error) => {
						setErroresFormulario([
							'Error al enviar la foto del paciente' + error.toString(),
						]);
						setModalErrores(true);
					});
			});
		};
	};

	const definirLocalidades = (id) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'localidadAll/?id_prov=' + id,
		}).then((response) => {
			let listaAxu = [];
			response.data.forEach((localidad) => {
				listaAxu.push({
					id: localidad.id,
					nombre: localidad.nombre,
					provincia: localidad.provincia,
				});
				if (Paciente.localidad !== undefined) {
					if (localidad.id.toString() === Paciente.localidad.toString()) {
						setLocalidad(localidad.nombre);
					}
				}
			});
			setListaLocalidades(listaAxu);
		});
	};

	const getListaProvincias = () => {
		let lista = [];
		ListaProvincias.forEach((prov) => {
			lista.push(prov.nombre);
		});
		setListaNombresProvincias(lista);
	};

	/**
	 * It changes the province.
	 */
	const cambiarProvincia = (provincia) => {
		definirLocalidades(provincia);
		ListaProvincias.forEach((prov) => {
			if (prov.id === provincia) {
				setProvincia(prov.nombre);
			}
		});
	};

	/**
	 * It sets the localidad of the empresa object to the localidad passed in.
	 */
	const cambiarLocalidad = (localidad) => {
		// setPaciente({...Paciente, localidad: localidad.toString()});
		ListaLocalidades.forEach((loc) => {
			if (loc.id.toString() === localidad.toString()) {
				setLocalidad(loc.nombre);
				setPaciente({...Paciente, localidad: loc});
			}
		});
	};

	const definirProvincias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'provinciaAll/',
		}).then((response) => {
			let listaAxu = [];
			axios({
				method: 'get',
				url: window.ipdirection + 'localidadAll/' + Paciente.localidad.id + '/',
			})
				.then((response2) => {
					axios({
						method: 'get',
						url: window.ipdirection + 'provinciaAll/' + response2.data.provincia.id + '/',
					})
						.then((response3) => {
							let provinciaCliente = response3.data;
							response.data.forEach((provincia) => {
								listaAxu.push(provincia);
								if (provincia.id === provinciaCliente.id) {
									definirLocalidades(provincia.id);
									setProvincia(provincia.nombre);
								}
							});
							setListaProvincias([...listaAxu]);
						})
						.catch((error) => console.log(error));
				})
				.catch((error) => console.log(error));
		});
	};
	const getProvinciasLocalidades = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'provinciaAll/',
		})
			.then((response) => {
				let listaAxu = [];
				response.data.forEach((provincia) => {
					listaAxu.push(provincia);
					if (provincia.id === 1) {
						definirLocalidades(provincia.id);
					}
				});
				setListaProvincias([...listaAxu]);
			})
			.catch((error) => console.log(error));
		/*
                axios({
                    method: 'get',
                    url: window.ipdirection + 'localidadAll/',
                }).then((response) => {
                    let listaAxu = []
                    response.data.forEach((localidad) => {
                        listaAxu.push(localidad)
                    });
                    setListaLocalidades([...listaAxu])
                    setLocalidad("Caceres")
                }).catch(error => console.log(error))
                */
	};

	useEffect(() => {
		if (Paciente.id !== undefined) {
			definirProvincias();
			cambiarLocalidad(Paciente.localidad);
		} else {
			getProvinciasLocalidades();
		}
		getListaProvincias();
	}, []);
	const classes = useStyles();

	const handleInpuntChange = (event) => {
		setPaciente({
			...Paciente,
			[event.target.name]: event.target.value,
		});
	};
	const handleInpuntChangeDNISS = (event) => {
		setPaciente({
			...Paciente,
			[event.target.name]: event.target.value.toUpperCase(),
		});
	};

	const validacionDatos = () => {
		let listaErrores = [];

		if (Paciente.notasPaciente === null) {
			setPaciente({...Paciente, notasPaciente: ''});
		}
		if (Paciente.notasPaciente === undefined) {
			setPaciente({...Paciente, notasPaciente: ''});
		}

		/* Checking if the phone number is correct. */
		if (!telefonoErroneo(Paciente.telefonoPaciente)) {
			listaErrores.push('El teléfono introducido es erróneo');
		}
		/* Checking if the phone number 2 is undefined, if it is, it is setting it to an empty string.
        If it is not undefined, it is checking if the phone number 2 is correct. */
		if (Paciente.telefonoDosPaciente === undefined) {
			setPaciente({...Paciente, telefonoDosPaciente: ''});
		} else {
			if (!telefonoErroneo(Paciente.telefonoPaciente)) {
				listaErrores.push('El teléfono 2 introducido es erróneo');
			}
		}
		/* Checking if the name of the patient is empty. */
		if (!datosVacio(Paciente.nombrePaciente)) {
			listaErrores.push('El nombre del paciente no puede estar vacio');
		}
		/* Checking if the last name of the patient is empty. */
		if (!datosVacio(Paciente.apellidosPaciente)) {
			listaErrores.push('Los apellidios del paciente no pueden estar vacios');
		}
		/* Checking if the DNI is correct. */
		if (!validarDNI(Paciente.dniPaciente)) {
			listaErrores.push('El DNI introducido es erróneo');
		}
		/* Checking if the postal code is correct. */
		if (!codigoPostalErroneo(Paciente.codigoPostalPaciente)) {
			listaErrores.push('El código postal introducido es erróneo');
		}
		/* Checking if the social security number is correct. */
		/*
                if (validarNISS(Paciente.numeroSS)) {
                    listaErrores.push("El número de la seguridad social introducido es erróneo, debe de tener 12 digitos numéricos")
                }
                */
		if (Paciente.fechaNacimiento === null) {
			listaErrores.push('El campo de la fecha de nacimiento no puede estar vacio');
		} else if (Paciente.fechaNacimiento === undefined) {
			listaErrores.push('El campo de la fecha de nacimiento no puede estar vacio');
		}
		/* Checking if the value is null or undefined. */
		if (Paciente.estadoCivil === null) {
			listaErrores.push('Debe seleccionar un estdo civil');
		} else if (Paciente.estadoCivil == undefined) {
			listaErrores.push('Debe seleccionar un estdo civil');
		}
		if (idPaciente === undefined) {
			let erroresFotoPerfil = true;
			if (FotoPerfilCambiar !== null) {
				if (FotoPerfilCambiar !== undefined) {
					if (FotoPerfilCambiar.fotoPerfil !== null) {
						if (FotoPerfilCambiar.fotoPerfil !== undefined) {
							if (
								FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpg' ||
								FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/png' ||
								FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpeg'
							) {
								erroresFotoPerfil = false;
							}
						}
					}
				}
			}
			if (erroresFotoPerfil) {
				listaErrores.push('Debe de añadir una foto de perfil en formato jpg, jpeg o png');
			}
		}

		if (listaErrores.length === 0) {
			/* Creating a new user. */

			return true;
		} else {
			/* Setting the error message error form to be displayed in the modal. */
			setErroresFormulario(listaErrores);
			setModalErrores(true);
			return false;
		}
	};

	return (
		<>
			<div className='centrador'>
				<div className='formulario-misPacientes'>
					<div className='contentFormularioMisPacientes'>
						<div className='fotoUser foto-misPacientes'>
							<div className='centrador divImagenPerfilFondo'>
								<img
									src={Paciente.fotoPaciente}
									className='imagenPerfilMiPerfil '
								/>
								<div className='iconoCambioFotoPerfil centrador'>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										fill='currentColor'
										className='bi bi-plus-circle-fill'
										viewBox='0 0 16 16'
										onClick={() => setModalCambiarFotoPerfil(true)}
									>
										<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
									</svg>
								</div>
							</div>
							<div className='centrador'>
								<div className='centrador nombreUsuarioForm'>
									{Paciente.nombrePaciente === undefined ||
									Paciente.nombrePaciente === ''
										? 'Nombre'
										: Paciente.nombrePaciente +
										  ' ' +
										  Paciente.apellidosPaciente}
								</div>
							</div>
						</div>
						<div className='datoFormularioUsuario '>
							<div className='labelDatoFormUsu'>
								<p>
									Nombre{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.nombrePaciente}
									name={'nombrePaciente'}
									placeholder='Nombre'
									onChange={handleInpuntChange}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Apellidos{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.apellidosPaciente}
									name={'apellidosPaciente'}
									placeholder='Apellidos'
									onChange={handleInpuntChange}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									DNI{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.dniPaciente}
									name={'dniPaciente'}
									placeholder='00000000X'
									onChange={handleInpuntChangeDNISS}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Provincia{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<Select
								className='inputTextUsuario inputDrop'
								id='provincia'
								renderValue={() => Provincia}
								value={Provincia}
								onChange={(event) => cambiarProvincia(event.target.value)}
							>
								{ListaProvincias.map((provincia, index) => (
									<MenuItem
										value={provincia.id}
										key={index}
									>
										{provincia.nombre}{' '}
									</MenuItem>
								))}
							</Select>
						</div>

						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Localidad{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<Select
								className='inputTextUsuario inputDrop'
								id='localidad'
								renderValue={() => Localidad}
								value={Localidad}
								onChange={(event) => cambiarLocalidad(event.target.value)}
							>
								{ListaLocalidades.map((localidad, index) => (
									<MenuItem
										value={localidad.id}
										key={index}
									>
										{localidad.nombre}{' '}
									</MenuItem>
								))}
							</Select>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Código postal{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.codigoPostalPaciente}
									name={'codigoPostalPaciente'}
									placeholder='10001'
									onChange={handleInpuntChange}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Dirección{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.direccionPaciente}
									name={'direccionPaciente'}
									placeholder='C/ Hoste Jualian 23'
									onChange={handleInpuntChange}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Teléfono{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.telefonoPaciente}
									name={'telefonoPaciente'}
									placeholder='666111222'
									onChange={handleInpuntChange}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>Teléfono 2</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.telefonoDosPaciente}
									name={'telefonoDosPaciente'}
									placeholder='666333444'
									onChange={handleInpuntChange}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Número Seguridad Social{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div>
								<input
									type='text'
									className='inputTextUsuario'
									value={Paciente.numeroSS}
									name={'numeroSS'}
									onChange={handleInpuntChangeDNISS}
									placeholder={'43523452345'}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuario-radio'>
							<div className='labelDatoFormUsu'>
								<p>
									Estado civil{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<div className='buttonRadioFormUsu'>
								<div className='contentButtonRadioFormUsu'>
									<div>Soltero</div>
									<input
										type='radio'
										checked={Paciente.estadoCivil}
										name={'estadoCivil'}
										onChange={() => {
											setPaciente({...Paciente, estadoCivil: true});
										}}
									/>
								</div>
								<div className='contentButtonRadioFormUsu'>
									<div>Casado</div>
									<input
										type='radio'
										name={'estadoCivil'}
										checked={!Paciente.estadoCivil}
										onChange={() => {
											setPaciente({...Paciente, estadoCivil: false});
										}}
									/>
								</div>
							</div>
						</div>
						<div className='datoFormularioUsuario'>
							<div className='labelDatoFormUsu'>
								<p>
									Fecha de nacimiento{' '}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</p>
							</div>
							<input
								type={'date'}
								value={Paciente.fechaNacimiento}
								onChange={(event) => {
									setPaciente({
										...Paciente,
										fechaNacimiento: event.target.value,
									});
								}}
								className={'inputTextUsuario'}
							/>
						</div>
						<div className='datoFormularioUsuarioNotas'>
							<div className='labelDatoFormUsuNotas'>Notas</div>
							<div className='inputNotas'>
								<input
									className='inputTextUsuario'
									type='text'
									value={Paciente.notasPaciente}
									name={'notasPaciente'}
									placeholder='Notas del paciente'
									onChange={handleInpuntChange}
								/>
							</div>
						</div>
						<div className='centrador-Botones-Pacientes'>
							<div
								className='button'
								onClick={() => {
									setPaciente();
									setIdPaciente();
									scroll.scrollToTop();
									setPantallaPerfil(false);
								}}
							>
								<b>Cancelar</b>
							</div>
							<div
								className='button'
								onClick={() => {
									if (validacionDatos()) {
										/* La letra del DNI y del NSS se pasan a mayusculas */
										guardarCambios();
									}
								}}
							>
								<b>Guardar</b>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Modal
				centered={true}
				isOpen={ModalFotoCambiadaNoOK}
			>
				<ModalHeader>
					<div className='titulo-modal'>Mi Empresa</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Ups... Parece que no se puede subir la foto
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalFotoCambiadaNoOK(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalCambiarFotoPerfil}
			>
				<ModalHeader>
					<div className='titulo-modal'>Actualiza la imagen del perfil del usuario</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						<p>Modifica la foto de perfil del usuario para mantener su información actualizada.</p>
						<input
							type='file'
							className='inputTextUsuario inputFile'
							accept='image/*'
							onChange={(e) =>
								setFotoPerfilCambiar({
									...setFotoPerfilCambiar,
									fotoPerfil: e.target.files[0],
								})
							}
						/>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='buttonB'
							onClick={() => {
								setFotoPerfilCambiar({});
								setModalCambiarFotoPerfil(false);
							}}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => actualizarFoto()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalFotoCambiadaOK}
			>
				<ModalHeader>
					<div className='titulo-modal'>Mi Empresa</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						La foto de perifl del usuario ha sido actualizada correctamente
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalFotoCambiadaOK(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
